module.exports = __webpack_public_path__ + "static/media/Download_Histogram_icon.1c33f1f2.svg";